import Marquee from "react-fast-marquee";
import { Apple, Play } from "lucide-react";

const WORDMARK =
  "https://customer-assets-lqy194kg.emergentagent.net/job_groundwork-webapp/artifacts/74z8pt9e_wordmark-orange-transparent.webp";

export const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-ink text-paper">
      {/* giant outline marquee */}
      <div className="overflow-hidden border-b-2 border-paper/20 py-8">
        <Marquee speed={30} gradient={false} autoFill>
          <span className="mx-8 font-bebas text-[14vw] uppercase leading-none tracking-tight text-outline">
            GROUNDWORK
          </span>
          <span className="mx-8 font-bebas text-[14vw] uppercase leading-none tracking-tight text-orange">
            GROUNDWORK
          </span>
        </Marquee>
      </div>

      <div className="mx-auto max-w-[1400px] px-5 py-16 sm:px-8">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-4">
          <div className="md:col-span-1">
            <img src={WORDMARK} alt="GROUNDWORK" className="h-7 w-auto" />
            <p className="mt-4 font-mono text-xs leading-relaxed text-paper/50">
              Field ops for street teams. Loud, flat, and functional.
            </p>
          </div>

          <div>
            <p className="mb-4 font-mono text-[10px] uppercase tracking-[0.2em] text-orange">Get in touch</p>
            <a
              href="mailto:info@groundworkmedia.app"
              data-testid="footer-email"
              className="font-mono text-sm text-paper/80 hover:text-orange"
            >
              info@groundworkmedia.app
            </a>
          </div>

          <div>
            <p className="mb-4 font-mono text-[10px] uppercase tracking-[0.2em] text-orange">Where we operate</p>
            <ul className="space-y-2 font-mono text-sm text-paper/80">
              <li>Los Angeles</li>
              <li>New York City</li>
              <li>Remote · US-wide</li>
            </ul>
          </div>

          <div>
            <p className="mb-4 font-mono text-[10px] uppercase tracking-[0.2em] text-orange">Download</p>
            <div className="flex flex-col gap-3">
              <div
                data-testid="footer-appstore"
                aria-disabled="true"
                title="Coming soon"
                className="flex cursor-not-allowed items-center justify-between gap-2 border-2 border-paper/50 px-4 py-2.5 font-mono text-xs uppercase tracking-wider text-paper/70"
              >
                <span className="flex items-center gap-2">
                  <Apple size={16} /> App Store
                </span>
                <span className="text-[9px] text-orange">Soon</span>
              </div>
              <div
                data-testid="footer-playstore"
                aria-disabled="true"
                title="Coming soon"
                className="flex cursor-not-allowed items-center justify-between gap-2 border-2 border-paper/50 px-4 py-2.5 font-mono text-xs uppercase tracking-wider text-paper/70"
              >
                <span className="flex items-center gap-2">
                  <Play size={16} /> Google Play
                </span>
                <span className="text-[9px] text-orange">Soon</span>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-3 border-t-2 border-paper/20 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-mono text-[11px] uppercase tracking-widest text-paper/40">
            © {new Date().getFullYear()} GROUNDWORK. All rights reserved.
          </p>
          <p className="font-mono text-[11px] uppercase tracking-widest text-paper/40">
            Built for the pavement.
          </p>
        </div>
      </div>
    </footer>
  );
};
